import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { FileText, Plus, Search, Shirt, Copy, Edit2 } from 'lucide-react';
import { Input } from '@/components/ui/input';

const PatternTemplatesPage = () => {
  // Placeholder template data
  const templates = [
    { id: 1, name: 'Classic Jacket Pattern', garmentType: 'Jacket', fields: 24, lastUpdated: '2024-12-27' },
    { id: 2, name: 'Slim Fit Trouser', garmentType: 'Trouser', fields: 18, lastUpdated: '2024-12-26' },
    { id: 3, name: 'Waistcoat Standard', garmentType: 'Waistcoat', fields: 12, lastUpdated: '2024-12-25' },
    { id: 4, name: 'Business Shirt', garmentType: 'Shirt', fields: 16, lastUpdated: '2024-12-24' },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="space-y-1">
          <h1 className="text-3xl font-semibold tracking-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Pattern Spec Templates
          </h1>
          <p className="text-muted-foreground">Manage pattern specification templates for different garment types</p>
        </div>
        <Button>
          <Plus className="w-4 h-4 mr-2" />
          New Template
        </Button>
      </div>

      {/* Search */}
      <Card className="border-white/10 bg-card">
        <CardContent className="pt-6">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input
              placeholder="Search templates..."
              className="pl-10"
            />
          </div>
        </CardContent>
      </Card>

      {/* Templates Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {templates.map((template) => (
          <Card key={template.id} className="border-white/10 bg-card hover:bg-secondary/30 transition-colors">
            <CardHeader>
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-lg bg-amber-500/10">
                    <FileText className="w-5 h-5 text-amber-500" />
                  </div>
                  <div>
                    <CardTitle className="text-base">{template.name}</CardTitle>
                    <Badge variant="secondary" className="mt-1">
                      <Shirt className="w-3 h-3 mr-1" />
                      {template.garmentType}
                    </Badge>
                  </div>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <div className="flex items-center justify-between text-sm text-muted-foreground">
                <span>{template.fields} specification fields</span>
                <span>Updated {template.lastUpdated}</span>
              </div>
              <div className="flex gap-2 mt-4">
                <Button variant="outline" size="sm" className="flex-1">
                  <Edit2 className="w-3 h-3 mr-1" />
                  Edit
                </Button>
                <Button variant="outline" size="sm" className="flex-1">
                  <Copy className="w-3 h-3 mr-1" />
                  Duplicate
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}

        {/* Add New Template Card */}
        <Card className="border-dashed border-2 border-slate-300 dark:border-slate-700 bg-transparent hover:bg-secondary/20 cursor-pointer transition-colors">
          <CardContent className="flex flex-col items-center justify-center h-full py-12">
            <Plus className="w-8 h-8 text-muted-foreground mb-2" />
            <p className="text-sm text-muted-foreground">Create New Template</p>
          </CardContent>
        </Card>
      </div>

      <Card className="border-dashed border-2 border-slate-300 dark:border-slate-700 bg-transparent">
        <CardContent className="py-8">
          <div className="text-center text-muted-foreground">
            <p className="text-sm">🚧 Pattern Templates functionality coming soon</p>
            <p className="text-xs mt-1">This page will allow you to create and manage measurement specification templates for different garment types</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PatternTemplatesPage;
